import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../services/api";
import Footer from "../../components/Layout/Footer";
import Navbar from "../../components/Layout/Navbar";
import { FaX } from "react-icons/fa6";
import { FaFacebook, FaLink, FaWhatsapp } from "react-icons/fa";

export default function BlogPost() {

  const { slug } = useParams();

  const [blog, setBlog] = useState(null);
  const [related, setRelated] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    const fetchBlog = async () => {

      try {

        const res = await api.get(`/blogs/post/${slug}`);

        setBlog(res.data.blog);
        setRelated(res.data.related || []);

      } catch (err) {

        console.error(err);
        setError("Failed to load blog");

      } finally {

        setLoading(false);

      }

    };

    fetchBlog();

  }, [slug]);

  if (loading) return <div style={styles.loading}>Loading blog...</div>;
  if (error) return <div style={styles.loading}>{error}</div>;
  if (!blog) return <div style={styles.loading}>Blog not found</div>;

  const wordCount = blog.content.split(" ").length;
  const readTime = Math.ceil(wordCount / 200);

  const shareUrl = window.location.href;

  return (
    <>
    <Navbar />
    <div style={styles.page}>

      <div style={styles.wrapper}>

        {/* MAIN ARTICLE */}

        <div style={styles.article}>

          {blog.category && (
            <div style={styles.category}>
              {blog.category.name}
            </div>
          )}

          <h1 style={styles.title}>{blog.title}</h1>

          <div style={styles.meta}>
            <span>{blog.views} views</span>
            <span>•</span>
            <span>{readTime} min read</span>
            <span>•</span>
            <span>
              {new Date(blog.publishedAt || blog.createdAt).toLocaleDateString()}
            </span>
          </div>

          {blog.coverImage && (
            <img
              src={blog.coverImage}
              alt={blog.title}
              style={styles.cover}
            />
          )}

          {blog.tags && blog.tags.length > 0 && (
            <div style={styles.tags}>
              {blog.tags.map((tag, i) => (
                <Link key={i} to={`/blog/tag/${tag}`} style={styles.tag}>
                  #{tag}
                </Link>
              ))}
            </div>
          )}

          <div style={styles.content}>
            {blog.content.split("\n").map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>

          {/* SHARE */}

          <div style={styles.shareSection}>

            <h4>Share this article</h4>

            <div style={styles.shareButtons}>

              <a
                href={`https://twitter.com/intent/tweet?url=${shareUrl}`}
                target="_blank"
                rel="noreferrer"
                style={styles.shareBtn}
              >
                <FaX />
              </a>

              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                target="_blank"
                rel="noreferrer"
                style={styles.shareBtn}
              >
                <FaFacebook />
              </a>

              <a
                href={`https://wa.me/?text=${shareUrl}`}
                target="_blank"
                rel="noreferrer"
                style={styles.shareBtn}
              >
                <FaWhatsapp />
              </a>
              <a
                href={blog.shortLink}
                target="_blank"
                rel="noreferrer"
                style={styles.shareBtn}
              >
                <FaLink />
              </a>
            </div>

          </div>

          {/* AUTHOR */}

          <div style={styles.authorBox}>

            <div style={styles.authorAvatar}>
              TF
            </div>

            <div>

              <div style={styles.authorName}>
                Tegafate
              </div>

              <div style={styles.authorBio}>
                Software developer and digital marketing specialist sharing
                tech tutorials, marketing tips, and online growth strategies.
              </div>

            </div>

          </div>

        </div>

        {/* SIDEBAR */}

        <aside style={styles.sidebar}>

          {/* SEARCH */}

          <div style={styles.widget}>
            <h4>Search</h4>
            <input
              placeholder="Search articles..."
              style={styles.searchInput}
            />
          </div>

{/* RECENT POSTS */}

<div style={styles.widget}>

  <h4 style={styles.widgetTitle}>Recent Articles</h4>

  {related.slice(0, 4).map((item) => (

    <Link
      key={item._id}
      to={`/blog/article/${item.slug}`}
      style={styles.recentPost}
    >

      <img
        src={item.coverImage}
        alt={item.title}
        style={styles.recentImage}
      />

      <div style={styles.recentContent}>
        <p style={styles.recentTitle}>
          {item.title}
        </p>
      </div>

    </Link>

  ))}

</div>

          {/* CTA */}

          <div style={styles.widgetCTA}>

            <h4>Try U2LR</h4>

            <p style={{fontSize:"14px"}}>
              Shorten your long links instantly and track clicks.
            </p>

            <Link
              to="/"
              style={styles.ctaButton}
            >
              Create Short Link
            </Link>

          </div>

          {/* TAGS */}

          {blog.tags && blog.tags.length > 0 && (

            <div style={styles.widget}>

              <h4>Tags</h4>

              <div style={styles.tags}>

                {blog.tags.map((tag, i) => (

                  <Link
                    key={i}
                    to={`/blog/tag/${tag}`}
                    style={styles.tag}
                  >
                    #{tag}
                  </Link>

                ))}

              </div>

            </div>

          )}

        </aside>

      </div>

    </div>
    <Footer />
    </>
  );
}

const styles = {

  page:{
    background:"#f8fafc",
    padding:"40px 20px",
    minHeight:"100vh"
  },

  wrapper:{
    maxWidth:"1200px",
    margin:"0 auto",
    display:"grid",
    gridTemplateColumns:"2fr 1fr",
    gap:"40px"
  },

  article:{
    // background:"#fff",
    padding:"40px",
    borderRadius:"12px",
    // border:"1px solid #e5e7eb"
  },

  sidebar:{
    position:"sticky",
    top:"100px",
    height:"fit-content"
  },

  widget:{
    background:"#fff",
    padding:"20px",
    border:"1px solid #e5e7eb",
    borderRadius:"10px",
    marginBottom:"20px"
  },

  widgetCTA:{
    background:"#2563eb",
    color:"#fff",
    padding:"20px",
    borderRadius:"10px",
    marginBottom:"20px"
  },

  ctaButton:{
    display:"inline-block",
    marginTop:"10px",
    background:"#fff",
    color:"#2563eb",
    padding:"8px 12px",
    borderRadius:"6px",
    textDecoration:"none",
    fontWeight:"600"
  },

  widgetLink:{
    display:"block",
    padding:"6px 0",
    textDecoration:"none",
    color:"#111827",
    fontSize:"14px"
  },

  searchInput:{
    width:"100%",
    padding:"8px",
    border:"1px solid #e5e7eb",
    borderRadius:"6px"
  },

  category:{
    display:"inline-block",
    background:"#ecfeff",
    color:"#0891b2",
    padding:"5px 10px",
    borderRadius:"6px",
    fontSize:"13px",
    fontWeight:"600",
    marginBottom:"10px"
  },

  title:{
    fontSize:"36px",
    fontWeight:"700",
    marginBottom:"10px"
  },

  meta:{
    display:"flex",
    gap:"10px",
    color:"#6b7280",
    fontSize:"14px",
    marginBottom:"25px"
  },

  cover:{
    width:"100%",
    borderRadius:"10px",
    marginBottom:"25px"
  },

  tags:{
    display:"flex",
    gap:"8px",
    flexWrap:"wrap",
    marginBottom:"25px"
  },

  tag:{
    background:"#eef2ff",
    color:"#4338ca",
    padding:"6px 10px",
    borderRadius:"6px",
    fontSize:"13px",
    textDecoration:"none"
  },

  content:{
    fontSize:"18px",
    lineHeight:"1.8"
  },

  shareSection:{
    marginTop:"40px"
  },

  shareButtons:{
    display:"flex",
    gap:"10px",
    marginTop:"10px"
  },

  shareBtn:{
    padding:"8px 12px",
    border:"1px solid #e5e7eb",
    borderRadius:"6px",
    textDecoration:"none",
    fontSize:"14px"
  },

  authorBox:{
    marginTop:"40px",
    display:"flex",
    gap:"15px",
    borderTop:"1px solid #e5e7eb",
    paddingTop:"20px"
  },

  authorAvatar:{
    width:"50px",
    height:"50px",
    borderRadius:"50%",
    background:"#2563eb",
    color:"#fff",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    fontWeight:"700"
  },

  authorName:{
    fontWeight:"600",
    marginBottom:"5px"
  },

  authorBio:{
    fontSize:"14px",
    color:"#6b7280"
  },

  loading:{
    textAlign:"center",
    padding:"80px",
    fontSize:"18px"
  },

  widgetTitle: {
  fontSize: "18px",
  fontWeight: "600",
  marginBottom: "15px"
},

recentPost: {
  display: "flex",
  gap: "12px",
  alignItems: "center",
  textDecoration: "none",
  marginBottom: "15px"
},

recentImage: {
  width: "80px",
  height: "60px",
  objectFit: "cover",
  borderRadius: "6px",
  flexShrink: 0
},

recentContent: {
  flex: 1
},

recentTitle: {
  fontSize: "14px",
  fontWeight: "500",
  color: "#111827",
  lineHeight: "1.3",
  margin: 0
},

};